import api from '@/api'
import {
  UPDATE_PERMISSION_LIST,
} from './mutation-type'
const state = {
  permissionList: [],
}
const mutations = {
  [UPDATE_PERMISSION_LIST](state, payload) {
    state.permissionList = payload
  },
}
const actions = {
  async getPermissionList ({state, commit}, payload) {
    const {data} = await api.adminApi.queryRoleList()
    if (data) {
      commit(UPDATE_PERMISSION_LIST, data)
    }
    return data
  },
  async addRole ({state}, payload) {
    const data = await api.adminApi.addRole(payload)
    return data
  },
  async cloneRole ({state}, payload) {
    const data = await api.adminApi.clonePermission(payload)
    return data
  },
  async deleteRole ({state}, payload) {
    const data = await api.adminApi.deleteRole(payload)
    return data
  },
  async queryCurrentAdminPermission ({state}, payload) {
    const data = await api.adminApi.queryPermissionByRoleId(payload)
    return data
  },
  async updateRolePermission ({state}, payload) {
    const data = await api.adminApi.updateRolePermission(payload)
    return data
  },
  // 列表处修改管理员、代理权限
  async alterRolePermission ({state}, payload) {
    const data = await api.adminApi.alterRolePermission(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
